module.exports = __webpack_public_path__ + "static/media/select.ef28433e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/select.png
// module id = 450
// module chunks = 0